<mat-card>
    <mat-card-content>
        <mat-card-title>{{'picture' | translate}}</mat-card-title>
        <mat-card-subtitle>{{'picture_desc' | translate}}</mat-card-subtitle>
        <app-file-uploader [disabled]="uploadingFile$ | async" [uploader]="uploader"></app-file-uploader>
    </mat-card-content>
</mat-card>
